import { Popover } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect } from "react";

const WIDTH_GAP = 35;
function TopPopover({ children, open, width, anchorEl, onClose, onEntered }) {
    function handle_onEntered() {
        if (onEntered) {
            onEntered();
        }
    }
    return (
        <Popover
            open={open}
            onClose={onClose}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            onEntered={handle_onEntered}
            transformOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
        >
            <div className={"fromPopoverContainer"} style={{ width }}>
                {children}
            </div>
        </Popover>
    );
}

function PopoverForm({
    trigger,
    children,
    exitPopover = false,
    onExitPopover = null,
    onClosePopover = null,
    beforeTrigger = null,
    afterTrigger = null,
    onEnteredPopover = null,
    minWidth = null,
}) {
    const [open, setOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [size, setSize] = React.useState(100);
    function onFocus(e) {
        setOpen(true);
        setAnchorEl(e.currentTarget);
        const _size = e.currentTarget.offsetWidth + WIDTH_GAP;
        if (_size > size && !minWidth) {
            setSize(_size);
        } else if (minWidth) {
            setSize(minWidth);
        }
    }
    function handle_onEntered() {
        if (onEnteredPopover) {
            onEnteredPopover();
        }
    }
    function onClose() {
        setOpen(false);
        setAnchorEl(null);
        if (onClosePopover) {
            onClosePopover();
        }
    }
    const _trigger = trigger
        ? React.cloneElement(trigger, {
            onClick: onFocus,
        })
        : null;
    useEffect(() => {
        if (exitPopover && open) {
            onClose();
            onExitPopover();
        }
    });
    return (
        <React.Fragment>
            {beforeTrigger || null}
            {_trigger}
            <TopPopover open={open} width={size} onEntered={handle_onEntered} onClose={onClose} anchorEl={anchorEl}>
                {children}
            </TopPopover>
            {afterTrigger}
        </React.Fragment>
    );
}

PopoverForm.propTypes = {
    trigger: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    exitPopover: PropTypes.bool,
    onExitPopover: PropTypes.func,
    onClosePopover: PropTypes.func,
    beforeTrigger: PropTypes.node,
    afterTrigger: PropTypes.node,
    onEnteredPopover: PropTypes.func,
    minWidth: PropTypes.number,
};


export default PopoverForm;
